import * as api from '../../api/index'
import * as endpoints from '../../api/endpoints'
import * as types from '../../api/../mutation-types'

const actions = {
    //Sm transactions
    createReceptionTransaction({commit}, payload) {
      return api.post(endpoints.SM_RECEPTION_TRANSACTION, payload,  commit,(response) => {
        commit(types.SET_SM_RECEPTION_TRANSACTION, response.data);
      });
    },
    createProductionTransaction({commit}, payload) {
      return api.post(endpoints.SM_PRODUCTION_TRANSACTION, payload,  commit,(response) => {
      });
    },
    createPreDividedProductionTransaction({commit}, payload) {
      return api.post(endpoints.SM_PRODUCTION_TRANSACTION_PRE_DIVIDED, payload, commit, (response) => {
      });
    },
    createSalesTransaction({commit}, payload) {
      return api.post(endpoints.SM_SALES_TRANSACTION, payload,  commit,(response) => {
        commit(types.SET_SM_SALES_TRANSACTION, response.data);
      });
    },
    createConsumTransaction({commit}, payload) {
      return api.post(endpoints.SM_CONSUM_TRANSACTION, payload,  commit,(response) => {
        commit(types.SET_SM_CONSUM_TRANSACTION, response.data);
      });
    },
    updateConsumTransaction({commit}, payload) {
      return api.put(endpoints.SM_CONSUM_TRANSACTION, payload, commit, (response) => {});
    },
    createMachineConsumTransaction({commit}, payload) {
        return api.post(endpoints.SM_MACHINE_CONSUM_TRANSACTION, payload,  commit,(response) => {
            commit(types.SET_SM_MACHINE_CONSUM_TRANSACTION, response.data);
        });
    },
    createTransferTransaction({commit}, payload) {
      return api.post(endpoints.SM_TRANSFER_TRANSACTION, payload,  commit,(response) => {
        commit(types.SET_SM_TRANSFER_TRANSACTION, response.data);
      });
    },
    createRequalificationTransaction({commit}, payload) {
      return api.post(endpoints.SM_REQUALIFICATION_TRANSACTION, payload,  commit,(response) => {
        commit(types.SET_SM_REQUALIFICATION_TRANSACTION, response.data);
      });
    },

    checkReceptionShippingNumberAlreadyExists({commit}, payload) {
      return api.fetch(endpoints.SM_RECEPTION_CHECK_SHIPPING_NUMBER, payload,  commit,(response) => {
      });
    },

    sendReceptionTransactionToErp({commit}, payload) {
      return api.post(endpoints.ERP_LEGACY_RECEPTIONS_EXPORT, payload, commit, (response) => {
      });
    },

    sendTransferTransactionToErp({commit}, payload) {
      return api.post(endpoints.ERP_LEGACY_TRANSFERS_EXPORT, payload, commit, (response) => {
      });
    },

    //regular transactions
    getSmTransactions({commit}, payload) {
      return api.fetch(endpoints.SM_TRANSACTIONS, payload, commit, (response) => {
        if(!payload.no_commit) {
          commit(types.SET_SM_TRANSACTIONS, response.data.data);
          commit("common/"+types.SET_PAGINATION, response.data.pagination, { root: true });
        }
      });
    },
    cancelSmTransaction({commit}, payload) {
      return api.remove(endpoints.SM_TRANSACTIONS_CANCEL, payload, commit, (response) => {
        commit(types.UPDATE_TRANSACTION, response.data.data);
      });
    },
    getSmTransactionTypes({commit}, payload) {
      return api.fetch(endpoints.SM_TRANSACTION_TYPES, payload, commit, (response) => {
        commit(types.SET_SM_TRANSACTION_TYPES, response.data);
      });
    },
    getSmStockMovements({commit}, payload) {
      return api.fetch(endpoints.SM_STOCK_MOVEMENTS, payload, commit, (response) => {
        commit(types.SET_SM_STOCK_MOVEMENTS, response.data.data);
        commit("common/"+types.SET_PAGINATION, response.data.pagination, { root: true });
      });
    },
    getSmStockMovementTypes({commit}, payload) {
      return api.fetch(endpoints.SM_STOCK_MOVEMENT_TYPES, payload, commit, (response) => {
        commit(types.SET_SM_STOCK_MOVEMENT_TYPES, response.data);
      });
    },
    getConsumTransactions({commit}, payload) {
      return api.fetch(endpoints.SM_CONSUM_TRANSACTION, payload,  commit,(response) => {

      });
    },
    getParcelConsum({commit}, payload) {
      return api.fetch(endpoints.PARCEL_CONSUM + "/" + payload.parcel_uuid + "?type=" + payload.type, payload,  commit,(response) => {
      });
    },
    getParcelConsumSummary({commit}, payload) {
      return api.fetch(endpoints.PARCEL_CONSUM_SUMMARY + "/" + payload.parcel_uuid + "?type=" + payload.type, payload,  commit,(response) => {
      });
    },
    getConsumSummary({commit}, payload) {
      return api.fetch(endpoints.CONSUM_SUMMARY, payload,  commit,(response) => {
      });
    },
    getParcelProduction({commit}, payload) {
      return api.fetch(endpoints.PARCEL_PRODUCTION, payload,  commit,(response) => {
      });
    },
     getParcelProductionSummary({commit}, payload) {
      return api.fetch(endpoints.PARCEL_PRODUCTION_SUMMARY, payload,  commit,(response) => {
      });
    },
    exportPdf({commit}, payload) {
      return api.downloadBlob(payload.url, payload, payload.type, commit,(response) => response.data);
    },
    downloadPdf({commit}, payload) {
      return api.downloadBlob(payload.url, payload, payload.type, commit,(response) => response.data);
    },
    getDownloadInfo({commit}, payload) {
      return api.fetchFull(payload.url, payload,  commit,(response) => {

      });
    },
    getExportInfo({commit}, payload) {
      return api.fetchFull(payload.url, payload,  commit,(response) => {

      });
    },

}

export default actions;
